import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => {
  return (
    <CircularProgress
      size={70}
      sx={{
        position: "fixed",
        left: "0",
        top: "50%",
        right: "0",
        margin: "0 auto",
        zIndex: 2,
      }}
    />
  );
};

export default Loader;
